import React from "react";
import DotLegalDeleteDialogWrapper from "../../common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { useTranslation } from "../../localization/useTranslation";
import { useDeleteAnnualWheelActivity } from "./DeleteAnnualWheelActivityDialog.hooks";
import { Box } from "@mui/material";
import { DotLegalHeader, DotLegalLink } from "@dotlegal/dotlegal-ui-components";
import { useUrlProvider } from "../../useUrlProvider";

export interface IDeleteAnnualWheelActivityDialogProps {
    activityId: string;
    activityName: string;
    onCloseDialog: () => void;
    onDeleteClick: () => void;
    hardDelete?: boolean;
    onFrameworkControl?: boolean;
}

function DeleteAnnualWheelActivityDialog(props: IDeleteAnnualWheelActivityDialogProps) {
    const urlProvider = useUrlProvider();
    const { translateString } = useTranslation();
    const { isFetchingControls, associatedControls, removeAnnualWheelActivity, inProgress } = useDeleteAnnualWheelActivity(props);

    const getAdditionalWarning = () => {
        let warning = props.hardDelete
            ? translateString("hardDeleteAnnualWheelActivityWarning")
            : (translateString("deleteAnnualWheelActivityWarning") as React.ReactNode);

        if (props.onFrameworkControl && associatedControls && associatedControls.length > 0) {
            warning = (
                <Box sx={{ "& .MuiTypography-root": { color: "inherit" } }}>
                    {warning}

                    <DotLegalHeader fontWeight={400} headerStyle={"small"} marginTop={4} marginBottom={0}>
                        {translateString("annualWheelActivityFrameworkControlsDeleteMsg")}
                    </DotLegalHeader>
                    <Box component={"ul"} sx={{ paddingLeft: "30px" }}>
                        {associatedControls.map((x, index) => {
                            return (
                                <Box component={"li"} key={x.frameworkControlId + "" + index}>
                                    <DotLegalLink linkColor={"primary"} to={urlProvider.getFrameworkControlOverviewUrl(x.frameworkControlId)}>
                                        {x.name}
                                    </DotLegalLink>
                                </Box>
                            );
                        })}
                    </Box>
                </Box>
            );
        }

        return warning;
    };

    return (
        <DotLegalDeleteDialogWrapper
            open
            inProgress={inProgress}
            itemForDeletion={props.activityName}
            additionalWarning={getAdditionalWarning()}
            onDialogClose={props.onCloseDialog}
            onOkClick={() => removeAnnualWheelActivity(props.hardDelete ?? false)}
            isLoading={isFetchingControls}
        />
    );
}

export default DeleteAnnualWheelActivityDialog;
